// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LikeOutlinedSvg from "@fishx/icons-svg/es/asn/LikeOutlined";
import FishxIcon from '../components/FishxIcon';

var LikeOutlined = function LikeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LikeOutlinedSvg
  }));
};

LikeOutlined.displayName = 'LikeOutlined';
export default React.forwardRef(LikeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LikeOutlined.js
// module id = 3035
// module chunks = 0